enum AdminAnnouncementColorEnum {
    INFO = 'text-blue',
    SUCCESS = 'text-green',
    WARNING = 'text-yellow',
    DANGER = 'text-red',
    OCTOBRE_ROSE = 'text-octobre-rose',
}

export default AdminAnnouncementColorEnum;
